<div class="landing-page">
  <nav
    class="landing-nav"
    [class.scrolled]="isNavScrolled"
    [class.menu-open]="mobileMenuOpen"
  >
    <div class="nav-inner">
      <div class="nav-brand" (click)="scrollTo('hero')">
        <img
          src="assets/reball/reball logo no bg.png"
          alt="ReBall"
          class="nav-logo"
        />
        <span class="nav-brand-text">ReBall</span>
      </div>
      <div class="nav-center">
        <a class="nav-link" (click)="scrollTo('features')">Features</a>
        <a class="nav-link" (click)="scrollTo('for-clubs')">For Clubs</a>
        <a class="nav-link" (click)="scrollTo('download')">Download</a>
      </div>
      <div class="nav-actions">
        <button class="nav-btn-ghost" (click)="goToLogin()">Log In</button>
        <button class="nav-btn-primary" (click)="goToRegister()">
          Get Started
        </button>
      </div>
      <button
        class="nav-hamburger"
        [class.active]="mobileMenuOpen"
        (click)="toggleMobileMenu()"
      >
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
      </button>
    </div>
    <div class="mobile-menu" [class.open]="mobileMenuOpen">
      <a class="mobile-link" (click)="scrollTo('features')">Features</a>
      <a class="mobile-link" (click)="scrollTo('for-clubs')">For Clubs</a>
      <a class="mobile-link" (click)="scrollTo('download')">Download</a>
      <div class="mobile-divider"></div>
      <button class="mobile-btn-ghost" (click)="goToLogin()">Log In</button>
      <button class="mobile-btn-primary" (click)="goToRegister()">
        Get Started
      </button>
    </div>
  </nav>

  <section class="hero" id="hero">
    <div class="hero-bg">
      <img
        src="assets/images/padel-bros.png"
        alt="Padel courts in Belgrade"
        class="hero-bg-img"
        loading="eager"
      />
      <div class="hero-overlay"></div>
    </div>
    <div class="hero-content">
      <div class="hero-text">
        <h1 class="hero-title">Book Your Court.<br />Own Your Game.</h1>
        <p class="hero-subtitle">
          Serbia's padel booking platform. Find courts, book instantly, and
          track your game -- all in one app.
        </p>
        <div class="hero-ctas">
          <button class="btn-primary-lg" (click)="goToRegister()">
            Create Free Account
          </button>
          <button class="btn-outline-lg" (click)="goToClubs()">
            Explore Clubs
          </button>
        </div>
        <div class="hero-store-badges">
          <a
            href="https://apps.apple.com/app/id6755013572"
            target="_blank"
            rel="noopener noreferrer"
            class="badge-link app-store-badge"
            aria-label="Download on the App Store"
          >
            <img
              src="assets/DownloadAppStore.svg"
              alt="Download on the App Store"
              class="store-badge-img"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=rs.padelpoint.app"
            target="_blank"
            rel="noopener noreferrer"
            class="badge-link google-play-badge"
            aria-label="Get it on Google Play"
          >
            <img
              src="assets/GetItOnGooglePlay.svg"
              alt="Get it on Google Play"
              class="store-badge-img"
            />
          </a>
        </div>
        <div class="hero-badge">
          <span class="badge-dot"></span>
          <span class="badge-text">Tennis & Table Tennis coming soon</span>
        </div>
      </div>
    </div>
    <div class="hero-stats">
      <div class="stats-bar">
        <div class="stat-item" *ngFor="let stat of stats">
          <span class="stat-value">{{ stat.value }}</span>
          <span class="stat-label">{{ stat.label }}</span>
        </div>
      </div>
    </div>
  </section>

  <section class="how-it-works" id="how-it-works">
    <div class="section-container">
      <div class="section-header animate-on-scroll" #animateOnScroll>
        <h2 class="section-title">How It Works</h2>
        <p class="section-subtitle">
          From finding a club to stepping on the court -- in three simple steps.
        </p>
      </div>
      <div class="steps-grid">
        <div
          class="step-card animate-on-scroll"
          *ngFor="let step of howItWorks; let i = index"
          #animateOnScroll
        >
          <div class="step-number">{{ i + 1 }}</div>
          <div class="step-icon-wrap">
            <img [src]="step.icon" [alt]="step.title" class="step-icon" />
          </div>
          <h3 class="step-title">{{ step.title }}</h3>
          <p class="step-desc">{{ step.description }}</p>
        </div>
      </div>
    </div>
  </section>

  <section class="features" id="features">
    <div class="section-container">
      <div class="section-header animate-on-scroll" #animateOnScroll>
        <h2 class="section-title">Everything You Need to Play</h2>
        <p class="section-subtitle">
          Real-time booking, competitive rankings, and a community of players.
        </p>
      </div>

      <div class="feature-row animate-on-scroll" #animateOnScroll>
        <div class="feature-image">
          <img
            src="assets/images/padel-court-1.png"
            alt="Padel courts at night with real-time availability on ReBall"
            loading="lazy"
          />
        </div>
        <div class="feature-text">
          <div class="feature-tag">Booking</div>
          <h3 class="feature-title">Real-Time Court Booking</h3>
          <p class="feature-desc">
            Browse multiple clubs, filter by indoor or outdoor courts, check
            live availability, and book your slot in seconds. See pricing
            upfront -- no surprises.
          </p>
          <ul class="feature-list">
            <li>Multiple clubs across Serbia</li>
            <li>Indoor & outdoor court filters</li>
            <li>Live availability and pricing</li>
            <li>Instant confirmation</li>
          </ul>
        </div>
      </div>

      <div class="feature-row reverse animate-on-scroll" #animateOnScroll>
        <div class="feature-image">
          <img
            src="assets/images/gladiator-sc.png"
            alt="Padel court at sunset in Serbia"
            loading="lazy"
          />
        </div>
        <div class="feature-text">
          <div class="feature-tag">Competition</div>
          <h3 class="feature-title">Match Tracking & Rankings</h3>
          <p class="feature-desc">
            Every match counts. Log results, earn RB Rank points, track your win
            rate, and compete for the top spot on the leaderboard.
          </p>
          <ul class="feature-list">
            <li>RB Rank points system</li>
            <li>Win/loss tracking</li>
            <li>Public leaderboard</li>
            <li>Full match history</li>
          </ul>
        </div>
      </div>

      <div class="feature-row animate-on-scroll" #animateOnScroll>
        <div class="feature-image">
          <img
            src="assets/images/court.png"
            alt="Aerial view of padel court booked through ReBall"
            loading="lazy"
          />
        </div>
        <div class="feature-text">
          <div class="feature-tag">Community</div>
          <h3 class="feature-title">Find Players & Build Your Crew</h3>
          <p class="feature-desc">
            Search for players, send friend requests, join clubs, and never
            struggle to fill a court again.
          </p>
          <ul class="feature-list">
            <li>Player search and invites</li>
            <li>Friend system</li>
            <li>Club memberships</li>
            <li>Player profiles with stats</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="coming-soon animate-on-scroll" #animateOnScroll>
    <div class="coming-soon-inner">
      <div class="sport-pills">
        <div class="sport-pill active">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <path
              d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
            />
          </svg>
          <span>Padel</span>
          <span class="pill-status live">Live</span>
        </div>
        <div class="sport-pill upcoming">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
          </svg>
          <span>Tennis</span>
          <span class="pill-status soon">Soon</span>
        </div>
        <div class="sport-pill upcoming">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
          </svg>
          <span>Table Tennis</span>
          <span class="pill-status soon">Soon</span>
        </div>
      </div>
      <h2 class="coming-soon-title">Padel is just the beginning.</h2>
      <p class="coming-soon-text">
        Tennis and Table Tennis are next. One app for all your racket sports.
      </p>
    </div>
  </section>

  <section class="for-clubs" id="for-clubs">
    <div class="section-container">
      <div class="clubs-split">
        <div class="clubs-text animate-on-scroll" #animateOnScroll>
          <div class="feature-tag club-tag">For Club Owners</div>
          <h2 class="section-title left-align">Grow Your Club with ReBall</h2>
          <p class="clubs-desc">
            A complete backoffice solution for padel clubs. Manage bookings,
            track analytics, and grow your player base -- all from one platform.
          </p>
          <div class="club-features-grid">
            <div class="club-feature" *ngFor="let feature of clubFeatures">
              <div class="club-feature-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path [attr.d]="feature.icon" />
                </svg>
              </div>
              <div class="club-feature-content">
                <h4 class="club-feature-title">{{ feature.title }}</h4>
                <p class="club-feature-desc">{{ feature.description }}</p>
              </div>
            </div>
          </div>
          <a
            class="btn-primary-lg club-cta"
            href="mailto:dimitrijek2005&#64;gmail.com"
            >Partner With Us</a
          >
        </div>
        <div class="clubs-image animate-on-scroll" #animateOnScroll>
          <img
            src="assets/images/padel-court-3.png"
            alt="Padel club managed through ReBall backoffice"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>

  <section class="download" id="download">
    <div class="section-container">
      <div class="download-content animate-on-scroll" #animateOnScroll>
        <div class="download-text">
          <h2 class="section-title left-align">Take ReBall With You</h2>
          <p class="download-desc">
            Book courts, track matches, and stay connected with your padel
            community -- right from your pocket.
          </p>
          <div class="store-badges">
            <a
              href="https://apps.apple.com/app/id6755013572"
              target="_blank"
              rel="noopener noreferrer"
              class="badge-link app-store-badge"
              aria-label="Download on the App Store"
            >
              <img
                src="assets/DownloadAppStore.svg"
                alt="Download on the App Store"
                class="store-badge-img"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=rs.padelpoint.app"
              target="_blank"
              rel="noopener noreferrer"
              class="badge-link google-play-badge"
              aria-label="Get it on Google Play"
            >
              <img
                src="assets/GetItOnGooglePlay.svg"
                alt="Get it on Google Play"
                class="store-badge-img"
              />
            </a>
          </div>
        </div>
        <div class="download-visual">
          <div class="phone-frame">
            <img
              src="assets/images/padel-court-5.png"
              alt="ReBall app showing padel court booking"
              loading="lazy"
              class="phone-screen"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="testimonials animate-on-scroll" #animateOnScroll>
    <div class="section-container">
      <div class="section-header">
        <h2 class="section-title">What Players Say</h2>
      </div>
      <div class="testimonials-grid">
        <div class="testimonial-card">
          <div class="testimonial-quote">
            ReBall made finding padel courts in Belgrade so much easier. I book
            my weekly games in under a minute now.
          </div>
          <div class="testimonial-author">
            <div class="author-avatar">M</div>
            <div class="author-info">
              <div class="author-name">Marko J.</div>
              <div class="author-role">Player, Belgrade</div>
            </div>
          </div>
        </div>
        <div class="testimonial-card">
          <div class="testimonial-quote">
            The backoffice tools saved us hours every week. Online bookings,
            analytics, employee management -- it has everything.
          </div>
          <div class="testimonial-author">
            <div class="author-avatar">S</div>
            <div class="author-info">
              <div class="author-name">Stefan R.</div>
              <div class="author-role">Club Owner, Novi Sad</div>
            </div>
          </div>
        </div>
        <div class="testimonial-card">
          <div class="testimonial-quote">
            The ranking system keeps us competitive. Tracking points and match
            history gives every game real stakes.
          </div>
          <div class="testimonial-author">
            <div class="author-avatar">A</div>
            <div class="author-info">
              <div class="author-name">Ana D.</div>
              <div class="author-role">Player, Belgrade</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="final-cta">
    <div class="final-cta-inner animate-on-scroll" #animateOnScroll>
      <img
        src="assets/reball/reball logo no bg.png"
        alt="ReBall"
        class="final-cta-logo"
      />
      <h2 class="final-cta-title">Ready to Play?</h2>
      <p class="final-cta-text">
        Join the growing padel community in Serbia. Create your free account and
        start booking today.
      </p>
      <div class="final-cta-buttons">
        <button class="btn-lime-lg" (click)="goToRegister()">
          Create Free Account
        </button>
        <button class="btn-outline-light-lg" (click)="goToClubs()">
          View Clubs
        </button>
      </div>
    </div>
  </section>

  <footer class="landing-footer">
    <div class="footer-inner">
      <div class="footer-top">
        <div class="footer-brand">
          <img
            src="assets/reball/reball logo no bg.png"
            alt="ReBall"
            class="footer-logo"
          />
          <span class="footer-brand-text">ReBall</span>
        </div>
        <div class="footer-links">
          <a routerLink="/privacy" class="footer-link">Privacy Policy</a>
          <a href="mailto:dimitrijek2005&#64;gmail.com" class="footer-link"
            >Contact</a
          >
        </div>
      </div>
      <div class="footer-bottom">
        <span class="footer-copy"
          >&copy; 2026 ReBall. All rights reserved.</span
        >
        <span class="footer-serbia">Made in Serbia</span>
      </div>
    </div>
  </footer>
</div>
